import React from 'react';

export const Calendar = ({}) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.75 6.5V4M16.25 6.5V4M20 14.4167H17.0833C16.1629 14.4167 15.4167 15.1629 15.4167 16.0833V19M12.5 13.1667V10.6667M13.75 11.9167H11.25M20 7.75V14.6311C20 15.2942 19.7366 15.9301 19.2678 16.3989L17.3989 18.2678C16.9301 18.7366 16.2942 19 15.6311 19H7.5C6.11929 19 5 17.8807 5 16.5V7.75C5 6.36929 6.11929 5.25 7.5 5.25H17.5C18.8807 5.25 20 6.36929 20 7.75Z" stroke="white" strokeOpacity="1" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
};
